'use strict';

customerZone

/***
 * Expects a positive amount expressed as euros (number) and formats it as a string of the format € #,##
 */
.filter('amountEuro', function(){
    return function(amountEuros){
        if (amountEuros === undefined) return undefined;
        if (amountEuros !== 0 && amountEuros < 0.01) return '< € 0,01';
        var rounded = (Math.ceil(amountEuros * 100) / 100).toFixed(2);
        return ('€ '+ rounded).replace('.', ',');
    };
})

/***
 * Expects a positive amount expressed as euros (number) and formats it as a string of the format € #
 */
.filter('amountEuroWhole', function(){
    return function(amountEuros){
        if (amountEuros === undefined) return undefined;
        var rounded = Math.round(amountEuros);
        if (rounded === 0 && amountEuros > 0) return '< € 1';
        return '€ '+ rounded;
    };
});
